import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export const ContentBannerWrapper = styled("div", {
    shouldForwardProp: prop => !["quickLinkCount", "enableContentBanner"].includes(prop as any),
})<{quickLinkCount: number; enableContentBanner: boolean}>`
    margin-left: auto;
    margin-right: auto;
    max-width: 1280px;
    display: grid;
    width: 100%;
    overflow: hidden;
    align-items: center;
    grid-template-columns: ${({quickLinkCount, enableContentBanner}) =>
        quickLinkCount > 0 && enableContentBanner
            ? ` ${98 - quickLinkCount * 10}% ${quickLinkCount * 10 + 2}% `
            : "100%"};

    @media (max-width: ${breakpoints.values.lg}px) {
        grid-template-columns: ${({quickLinkCount, enableContentBanner}) =>
            quickLinkCount > 0 && enableContentBanner
                ? ` ${90 - quickLinkCount * 10}% ${quickLinkCount * 10 + 10}% `
                : "100%"};
    }

    @media (max-width: ${breakpoints.values.md - 1}px) {
        grid-template-columns: 100%;
    }

    @media (max-width: ${breakpoints.values.sm}px) {
        width: 100%;
        display: grid;
        justify-content: center;
        padding: 0;
    }
`
